import Vue from 'vue'
import { Button, Tabs, TabPane, Breadcrumb, BreadcrumbItem, Pagination } from 'element-ui'

Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Pagination)